import { render } from "./ModalPaymentTelemed.vue?vue&type=template&id=d8c5bbaa&scoped=true"
import script from "./ModalPaymentTelemed.vue?vue&type=script&lang=js"
export * from "./ModalPaymentTelemed.vue?vue&type=script&lang=js"

import "./ModalPaymentTelemed.vue?vue&type=style&index=0&id=d8c5bbaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c5bbaa"]])

export default __exports__